import { CookieConsentProvider } from '@use-cookie-consent/react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Helmet } from 'react-helmet';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useParams } from 'react-router';
import ApolloCookieConsent from './components/ApolloCookieConsent';
import ResolvePage from './ResolvePage';
import HotspotOverview from '../views/hotspot/HotspotOverview';
import HotspotDetail from '../views/hotspot/HotspotDetail';
import Preloader from '../components/Preloader';
import Redirect from '../components/Redirect';

function HotspotHyphenRedirect() {
    const { location } = useParams();
    return <Redirect url={`/hotspots/${location}`} />;
}

export default function Apollo() {
    return (
        <>
            <Preloader />
            <GoogleReCaptchaProvider reCaptchaKey={process.env.MIX_REACT_APP_RECAPTCHA}>
                <BrowserRouter>
                    <CookieConsentProvider>
                        <Helmet>
                            <title>{process.env.MIX_REACT_APP_APP_NAME}</title>
                        </Helmet>

                        <Routes>
                            <Route path="/">
                                <Route
                                    path="app/google-play"
                                    element={
                                        <Redirect url="https://play.google.com/store/apps/details?id=nl.bragis.onrouteorg&hl=nl&gl=US" />
                                    }
                                />
                                <Route
                                    path="app/apple-store"
                                    element={<Redirect url="https://apps.apple.com/nl/app/onroute/id928695490" />}
                                />

                                <Route index element={<ResolvePage />} />
                                {/* Framework routes */}
                                <Route path="hotspots-:location" element={<HotspotHyphenRedirect />} />
                                <Route path="hotspots/:location" element={<HotspotOverview />} />
                                <Route path="hotspots/:location/:hotspot" element={<HotspotDetail />} />

                                {/* <Route path="succesverhalen/:name" element={<CaseDetail />} /> */}

                                {/* <Route path="onze-diensten/:category" element={<ServiceDetail />} /> */}
                                {/* <Route path="onze-diensten/:category/:name" element={<ServiceDetail />} /> */}

                                <Route path=":path">
                                    <Route path=":id" element={<ResolvePage />} />
                                    <Route path=":id/:urlTitle" element={<ResolvePage detailPage />} />
                                    <Route index element={<ResolvePage />} />
                                </Route>
                            </Route>
                        </Routes>
                        <ApolloCookieConsent />
                    </CookieConsentProvider>
                </BrowserRouter>
            </GoogleReCaptchaProvider>
        </>
    );
}
